// extracted by mini-css-extract-plugin
export default {"slides":"SlideTransition_slides__2dRGM","slide":"SlideTransition_slide__MjTzh","slideContainer":"SlideTransition_slideContainer__q5shX","active":"SlideTransition_active__lN8Kd"};